import TopFeatures from './TopFeatures'

export default TopFeatures
